module.exports = "<span data-seek-time></span>\n<span data-duration></span>\n";